import { render, staticRenderFns } from "./Weight5thWeek.vue?vue&type=template&id=314183a4&scoped=true"
import script from "./Weight5thWeek.vue?vue&type=script&lang=js"
export * from "./Weight5thWeek.vue?vue&type=script&lang=js"
import style0 from "./Weight5thWeek.vue?vue&type=style&index=0&id=314183a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314183a4",
  null
  
)

export default component.exports